import { useLayoutEffect, useState } from 'react'

interface UseCreatePortalRoot {
  rootId: string
  disabled?: boolean
}

function useCreatePortalRoot({ rootId, disabled }: UseCreatePortalRoot) {
  const [portalRoot, setPortalRoot] = useState<HTMLElement | null>(document.getElementById(rootId))

  useLayoutEffect(() => {
    if (portalRoot || disabled) return

    const root = document.createElement('div')
    root.id = rootId

    document.body.appendChild(root)
    setPortalRoot(root)
  }, [portalRoot, rootId, disabled])

  return portalRoot
}

export { useCreatePortalRoot }
